import get from 'lodash/get'
import { ListingSectionObject } from '../transports/common/listing-section-transport'

import { FormattedClassificationTransport } from '../transports/common/listing-transport'
import { TranslationFunction } from '../common/types'

export const formatClassification = (
    listingObject: ListingSectionObject,
    t: TranslationFunction,
): FormattedClassificationTransport | null => {
    const classification = get(listingObject, 'classification', null)

    if (classification) {
        const locatedInGermany = get(classification, 'locatedInGermany')
        const starsCount = get(classification, 'stars')
        const validUntil = get(classification, 'validUntil')
        const isValid = validUntil ? new Date(validUntil).getTime() > Date.now() : false

        if (starsCount > 0 && isValid) {
            let description = null

            description = locatedInGermany
                ? t('classification.dtv.description')
                : t('classification.default.description')

            return {
                description,
                starsCount,
            }
        }

        return null
    }

    return null
}
